import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { debounceTime, timeout } from 'rxjs/operators';
import { SearchService } from '../services/search/search.service';
import { ContextService } from '../services/context/context.service';
import { DataService } from '../services/context/data.service';
import { RefDataService } from '../services/context/ref-data.service';
import { UIStateService } from '../services/context/uistate.service';
import { ChartDataService } from '../services/context/chart-data.service';

import { PlanService } from '../services/plan.service';
import * as fromModel from '../services/models/';
import { Constant } from '../../environments/constants';
import { AppMonitoringService } from '../services/util/app-monitoring.service';
import { UserService } from '../services/context/user.service';
import { MatDialog } from '@angular/material/dialog';
import { DeletePlanComponent } from '../context-components/delete-plan/delete-plan.component';

@Component({
  selector: 'gp-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  searchControl = new FormControl('', [Validators.maxLength(12)]);

  clientList: any[] =  [];
  planList: any[] = [];
  accountList: any[] =  [];  


  isSuperUser=false;
  loggedInUserId;
  deleteConfrimation = false;
  planIdForDelete;
  planNameForDelete;


  
  displayedColumns: string[] = ['planName', 'clientname', 'createddatetime', 'updateddatetime', 'actions'];
  dataSource;
  
  buinessClientTooltip = Constant.ToolTips.buinessClientTooltip;
  showProgress = false;
  
  constructor(private searchService: SearchService, 
              private contextService: ContextService,
              private dataService: DataService,
              private userService: UserService,
              private refDataService: RefDataService,
              private uiStateService: UIStateService, 
              private chartDataService: ChartDataService, 
              private planService: PlanService,
              private dialog: MatDialog, 
              private appMonitoringService: AppMonitoringService) { }

  ngOnInit(): void {

    console.log("%c Enter: GPT Home Init", Constant.consoleLogStyle.frameworkDocument);
    this.appMonitoringService.traceMsg("Enter: GPT  Init", 'Information');

    this.gptReset();

    this.isSuperUser = this.userService.getUser().isSuperUser;
    this.loggedInUserId = this.userService.getUser().primaryEmail;
        
    this.searchControl.valueChanges
    .pipe(
      debounceTime(500)
    ).subscribe (
      searchText => {
        //if(searchText){
          this.searchService.searchClients(searchText).subscribe(
            searchResultResult => {
              this.clientList = <any[]>searchResultResult;                       
            }
          );
          this.searchService.searchAccounts(searchText).subscribe(
            searchResultResult => {
              this.accountList = <any[]>searchResultResult;                       
            }
          );
        //}  
      }
    );

    this.getPlanList();

    console.log("%c Exit: GPT Home Init", Constant.consoleLogStyle.frameworkDocument);
  }

  getPlanList(){
    let data;
    let tempPlanList = [];
    this.showProgress  = true;
    this.planService.getPlanList().subscribe(pList => {
      if(pList && pList['plans'] && pList['plans'].length>0){
        this.planList = <any[]>pList['plans'];
        this.planList.forEach(pl => {
          //url = `/plan/${encodeURIComponent(' ')}`;
          data = this.preparePlanList(pl);
          tempPlanList.push(data);            
        });        
        this.dataSource = tempPlanList;
        this.showProgress = false;
      }
    }, err=>{
      this.showProgress = false;
      console.log("Error getting Plan List - HomeComponent-getPlanList");      
      this.appMonitoringService.traceMsg("Error: Error getting Plan List - HomeComponent-getPlanList", JSON.stringify(err), 'Error');
    });
  }

  onClientSelectionChange(selectedClient){ 
    this.updatePlanList(selectedClient, 'client');    
  }

  onAccountSelectionChange(selectedAccount){
    this.updatePlanList(selectedAccount, 'account');
  }

  updatePlanList(cl, context){
    let data;
    let tempClientList = [];
    let acc = [];

    if(context === 'client'){
       acc = cl.Account;
    } else if(context === 'account'){
      acc.push(cl.id);
    } 
    data = this.preparePlanListWithClientData(cl, acc);
    tempClientList.push(data);
    this.dataSource = tempClientList;
  }

  preparePlanList(pl) {    
    let primaryClient = pl.planClients.find(cl=> cl.role === fromModel.CLIENTROLE.Primary);
    let data = {planId: pl.id, planName: pl.planName, plantype: '', createddatetime:pl.createdDt, updateddatetime:pl.updatedDt, createdby:pl.createdBy, updatedby:pl.updatedBy, 
                    clientid: primaryClient.clientid, clientType: 'Individual', clientname: primaryClient.clientname, dob: primaryClient.dob, role: <fromModel.CLIENTROLE>primaryClient.role, 
                    retAge: primaryClient.retAge,Account: pl.planAccounts};
    return data;
  }

  preparePlanListWithClientData(cl,ac?) {
    let primaryClient;
    let isSearchedClInPlanList = false;
    let data;
    if(!ac){
      ac = cl.Account;
    }      
    this.planList.forEach(pl => {
      primaryClient = pl.planClients.find(cl=> cl.role === fromModel.CLIENTROLE.Primary);
      if(primaryClient){
        if(primaryClient.clientid.trim() === cl.LegalEntityID.trim()){
          data = this.preparePlanList(pl);
          isSearchedClInPlanList = true;
        } 
      }
    });    

    if(!isSearchedClInPlanList){
      data = {planId: ' ', planName: '', plantype: '', createddatetime:'', updateddatetime:'', createdby:'', updatedby:'', 
              clientid: cl.LegalEntityID, clientType: cl.legalEntityType, clientname: cl.LegalEntityName, dob: cl.dateofBirth, role: fromModel.CLIENTROLE.Primary, 
              retAge: fromModel.DEFAULTS.retAge,Account: ac};
    }
    return data;      
  } 
  deletePlan(planId, planName){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEPLAN, planId, planName)
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, planId?: string, planName?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.DELETEPLAN: {
        const dialogRef = this.dialog.open(DeletePlanComponent, {
          width: '500px',
          height: '240px',
          data: { planId: planId, planName: planName}                  
        }).afterClosed()
        .subscribe(isPlanDeleted => {
          if(isPlanDeleted){
            this.getPlanList();
          }
        });
        break;
      }     
    }
  }

  gptReset(){
    this.contextService.dispatchAction(fromModel.APP_ACTION.RESET, "HomeComponent - gptReset", null);
    this.dataService.dispatchAction(fromModel.DATA_ACTION.RESET, "HomeComponent - gptReset", null);    
    this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.RESET, "HomeComponent - gptReset", null);     
    this.refDataService.dispatchAction(fromModel.REF_DATA_ACTION.STATEEXP, "HomeComponent - gptReset", null);
    this.chartDataService.dispatchAction(fromModel.CHART_DATA_ACTION.RESET, "PlanComponent - gptReset", null);     
  }
}
